import { generateSlugFromTerritoryName } from 't2-keystone/src/schema/Territory/services/generateSlugFromTerritoryName';
import { EMPTY_TERRITORY_PAGE_URL } from './constants';

export const generateTerritoryUrlFromSlug = (territorySlug: string) => `${EMPTY_TERRITORY_PAGE_URL}${territorySlug}`;
export const generateTerritoryUrlFromTerritoryName = (territoryName: string) =>
  generateTerritoryUrlFromSlug(generateSlugFromTerritoryName(territoryName));
export const normalizeTerritorySlug = (territorySlug: string) => territorySlug?.split(EMPTY_TERRITORY_PAGE_URL)?.[1];
